module.exports = __webpack_public_path__ + "img/nasa-logo.ae42d855.png";